import ACTIONS from "./VisitorLogsActionsTypes";

//OTP ACTION
export const postOTPActionRequest = (payload) => ({
  type: ACTIONS.POST_OTP_ACTION_REQUEST,
  payload,
});

export const postOTPActionResponse = (payload) => ({
  type: ACTIONS.POST_OTP_ACTION_RESPONSE,
  payload,
});

export const postOTPActionResponseClear = () => ({
  type: ACTIONS.POST_OTP_ACTION_RESPONSE_CLEAR,
});

//UPLOAD

export const postMediaUploadRequest = (payload) => ({
  type: ACTIONS.POST_MEDIA_UPLOAD_REQUEST,
  payload,
});

export const postMediaUploadResponse = (payload) => ({
  type: ACTIONS.POST_MEDIA_UPLOAD_RESPONSE,
  payload,
});

export const postMediaUploadResponseClear = () => ({
  type: ACTIONS.POST_MEDIA_UPLOAD_RESPONSE_CLEAR,
});

//POST

export const postVistorLogRequest = (payload) => ({
  type: ACTIONS.POST_VISTOR_LOG_REQUEST,
  payload,
});

export const postVistorLogResponse = (payload) => ({
  type: ACTIONS.POST_VISTOR_LOG_RESPONSE,
  payload,
});

export const postVisitorLogResponseClear = () => ({
  type: ACTIONS.POST_VISTOR_LOG_RESPONSE_CLEAR,
});

//PUT

export const putVisitorLogRequest = (payload) => ({
  type: ACTIONS.PUT_VISTOR_LOG_REQUEST,
  payload,
});

export const putVisitorLogResponse = (payload) => ({
  type: ACTIONS.PUT_VISTOR_LOG_RESPONSE,
  payload,
});

//PUT STATUS

export const putStatusChangeRequest = (payload) => ({
  type: ACTIONS.PUT_STATUS_VISTOR_LOG_REQUEST,
  payload,
});

export const putStatusChangeResponse = (payload) => ({
  type: ACTIONS.PUT_STATUS_VISTOR_LOG_RESPONSE,
  payload,
});

//

export const getVisitorLogsRequest = (payload) => ({
  type: ACTIONS.GET_VISITOR_LOGS_REQUEST,
  payload,
});

export const getVisitorLogsResponse = (payload) => ({
  type: ACTIONS.GET_VISITOR_LOGS_RESPONSE,
  payload,
});

export const getVisitorLogsResponseClear = (payload) => ({
  type: ACTIONS.GET_VISITOR_LOGS_RESPONSE_CLEAR,
  payload,
});

//

export const getSingleVisitorLogRequest = (payload) => ({
  type: ACTIONS.GET_SINGLE_VISITOR_LOGS_REQUEST,
  payload,
});

export const getSingleVisitorLogResponse = (payload) => ({
  type: ACTIONS.GET_SINGLE_VISITOR_LOGS_RESPONSE,
  payload,
});

export const getSingleVisitorLogResponseClear = (payload) => ({
  type: ACTIONS.GET_SINGLE_VISITOR_LOGS_RESPONSE_CLEAR,
  payload,
});

//

export const postExcelUploadVisitorLogRequest = (payload) => ({
  type: ACTIONS.POST_EXCEL_VISITOR_LOG_REQUEST,
  payload,
});

export const postExcelUploadVisitorLogResponse = (payload) => ({
  type: ACTIONS.POST_EXCEL_VISITOR_LOG_RESPONSE,
  payload,
});

export const postExcelUploadVisitorLogResponseClear = () => ({
  type: ACTIONS.POST_EXCEL_VISITOR_LOG_RESPONSE_CLEAR,
});

//

export const postExcelUploadRecordsVisitorLogRequest = (payload) => ({
  type: ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_REQUEST,
  payload,
});

export const postExcelUploadRecordsVisitorLogResponse = (payload) => ({
  type: ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE,
  payload,
});

export const postExcelUploadRecordsVisitorLogResponseClear = () => ({
  type: ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE_CLEAR,
});

//

export const deleteVisitorLogRequest = (payload) => ({
  type: ACTIONS.DELETE_VISITOR_LOG_REQUEST,
  payload,
});

export const deleteVisitorLogResponse = (payload) => ({
  type: ACTIONS.DELETE_VISITOR_LOG_RESPONSE,
  payload,
});

export const deleteVisitorLogResponseClear = () => ({
  type: ACTIONS.DELETE_VISITOR_LOG_RESPONSE_CLEAR,
});

export const putVisitorLogReminderRequest = (payload) => ({
  type: ACTIONS.PUT_VISTOR_LOG_REMINDER_REQUEST,
  payload,
});

export const putVisitorLogReminderResponse = (payload) => ({
  type: ACTIONS.PUT_VISTOR_LOG_REMINDER_RESPONSE,
  payload,
});

//

export const putCheckoutVisitorLogRequest = (payload) => ({
  type: ACTIONS.PUT_CHECKOUT_VISTOR_LOG_REQUEST,
  payload,
});

export const putCheckoutVisitorLogResponse = (payload) => ({
  type: ACTIONS.PUT_CHECKOUT_VISTOR_LOG_RESPONSE,
  payload,
});
